// extracted by mini-css-extract-plugin
export default {"indicatorIcon":"otp_indicatorIcon__TuaK8","slide":"otp_slide__L1tyV"};